import { ChatMessageRole } from "@/types/chatbot.types";

export enum FeedbackMessageType {
    CHATBOT_FEEDBACK = "CHATBOT_FEEDBACK",
}

export type CreateFeedbackPayload = {
    message: string;
    messageType: FeedbackMessageType;
    conversation: Array<{
        role: ChatMessageRole;
        content: string;
    }>;
};
